import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function NavBar({ token, setToken }) {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  
  useEffect(() => {
    if (!token) return;
    setIsLoggedIn(true);
  }, [token]);

  function logout() {
    localStorage.removeItem("token");
    localStorage.removeItem("username");
    setIsLoggedIn(false);
    setToken(null);
  }

  return (
    <nav className="navMenu">
      <div className="navTitle">
        <span>Fitness Tracker™</span>
      </div>
      <div className="dot"></div>
      <div className="">
      <Link to="Home">Home</Link>
        <Link to="Activities">Activities</Link>
        <Link to="Routines">Routines</Link>
        {!isLoggedIn && <Link to="Login">Login</Link>}
        {isLoggedIn && (
          <>
            <Link to="/Login" onClick={logout}>Logout</Link>
            <Link to="Profile">Profile</Link>
          </>
        )}
      </div>
    </nav>
  );
}